import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Container,
  TextField,
  Typography,
  Autocomplete,
} from "@mui/material";
import { db } from "../../firebase/firebaseConfig";
import { collection, getDocs, addDoc } from "firebase/firestore";

// Lista de países de América y Europa
const COUNTRIES = [
  "Argentina", "Bolivia", "Brasil", "Chile", "Colombia", "Costa Rica", "Cuba",
  "Ecuador", "El Salvador", "Guatemala", "Honduras", "México", "Nicaragua",
  "Panamá", "Paraguay", "Perú", "República Dominicana", "Uruguay", "Venezuela",
  "Alemania", "Austria", "Bélgica", "Bulgaria", "Croacia", "Dinamarca",
  "Eslovaquia", "Eslovenia", "España", "Estonia", "Finlandia", "Francia",
  "Grecia", "Hungría", "Irlanda", "Italia", "Letonia", "Lituania", "Luxemburgo",
  "Malta", "Países Bajos", "Polonia", "Portugal", "Rumania", "Suecia",
  "República Checa"
];

const AddMemberPage = () => {
  const [formData, setFormData] = useState({ ID_SOCIO: "", PAIS: "" });
  const [nextId, setNextId] = useState(null);

  useEffect(() => {
    const fetchNextId = async () => {
      const snapshot = await getDocs(collection(db, "miembros"));
      const maxId = Math.max(...snapshot.docs.map(doc => doc.data().ID || 0));
      setNextId(maxId + 1);
    };
    fetchNextId();
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSelectCountry = (_, value) => {
    setFormData({ ...formData, PAIS: value });
  };

  const handleSubmit = async () => {
    try {
      await addDoc(collection(db, "miembros"), {
        ...formData,
        ID: nextId,
      });
      alert("Miembro agregado correctamente");
    } catch (error) {
      console.error("Error al guardar el miembro:", error);
      alert("Hubo un error al guardar el miembro");
    }
  };

  return (
    <Container>
      <Box maxWidth="md" mx="auto">
        <Typography variant="h4" mt={8} mb={8}>Agregar Miembro</Typography>
        <Box display="flex" flexDirection="column" gap={4}>
        <Typography variant="h6" mt={4}>Datos Personales del Socio</Typography>
        <TextField
          label="ID"
          value={nextId ?? "Cargando..."}
          disabled
        />
        <TextField
          name="ID_SOCIO"
          label="ID del Socio"
          value={formData.ID_SOCIO}
          onChange={handleChange}
        />
        <Autocomplete
          options={COUNTRIES}
          value={formData.PAIS}
          onChange={handleSelectCountry}
          renderInput={(params) => (
            <TextField {...params} label="País" />
          )}
          disableClearable
          filterSelectedOptions
          autoHighlight
        />
        <TextField
          name="NOMBRE_APELLIDO"
          label="Nombre y Apellido"
          value={formData.NOMBRE_APELLIDO || ""}
          onChange={handleChange}
        />
        <TextField
          name="IDENTIFICACION"
          label="Identificación"
          value={formData.IDENTIFICACION || ""}
          onChange={handleChange}
        />
        <TextField
          name="LUGAR_FECHA_NACIMIENTO"
          label="Lugar y Fecha de Nacimiento"
          value={formData.LUGAR_FECHA_NACIMIENTO || ""}
          onChange={handleChange}
        />
        <TextField
          name="TELEFONOS"
          label="Teléfonos"
          value={formData.TELEFONOS || ""}
          onChange={handleChange}
        />
        <TextField
          name="EMAIL"
          label="Email"
          value={formData.EMAIL || ""}
          onChange={handleChange}
        />
        <TextField
          select
          name="GENERO"
          label="Género"
          fullWidth
          value={formData.GENERO || ""}
          onChange={handleChange}
          SelectProps={{ native: true }}
        >
          <option value="">Seleccione...</option>
          <option value="Hombre">Hombre</option>
          <option value="Mujer">Mujer</option>
          <option value="No Binario">No Binario</option>
        </TextField>
        <TextField
          name="TIPO_SOCIO"
          label="Tipo de Socio"
          value={formData.TIPO_SOCIO || ""}
          onChange={handleChange}
        />
        <TextField
          select
          name="ESTADO_MEMBRESIA"
          label="Estado de Membresía"
          fullWidth
          value={formData.ESTADO_MEMBRESIA || ""}
          onChange={handleChange}
          SelectProps={{ native: true }}
        >
          <option value="">Seleccione...</option>
          <option value="Activo">Activo</option>
          <option value="Inactivo">Inactivo</option>
        </TextField>
        <TextField
          name="FECHA_MEMBRESIA"
          label="Fecha de Membresía"
          value={formData.FECHA_MEMBRESIA || ""}
          onChange={handleChange}
        />
        <Typography variant="h6" mt={4}>Datos Profesionales y Laborales</Typography>
        <TextField
          name="CARGO"
          label="Cargo"
          value={formData.CARGO || ""}
          onChange={handleChange}
        />
        <TextField
          name="CARGOS_DESEMPENADOS_GCIAMT"
          label="Cargos Desempeñados en GCIAMT"
          value={formData.CARGOS_DESEMPENADOS_GCIAMT || ""}
          onChange={handleChange}
        />
        <TextField
          name="FORMACION_PROFESIONAL"
          label="Formación Profesional"
          value={formData.FORMACION_PROFESIONAL || ""}
          onChange={handleChange}
        />
        <TextField
          name="DIRECCION_LABORAL"
          label="Dirección Laboral"
          value={formData.DIRECCION_LABORAL || ""}
          onChange={handleChange}
        />
        <TextField
          name="INSTITUCION_LABORAL"
          label="Institución Laboral"
          value={formData.INSTITUCION_LABORAL || ""}
          onChange={handleChange}
        />
        <TextField
          name="MIEMBRO_OTRAS_SOCIEDADES"
          label="Miembro de Otras Sociedades"
          value={formData.MIEMBRO_OTRAS_SOCIEDADES || ""}
          onChange={handleChange}
        />
        <Button variant="contained" onClick={handleSubmit}>
          Guardar Miembro
        </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default AddMemberPage;